import { render } from "./Vaults.vue?vue&type=template&id=153fec00&scoped=true"
import script from "./Vaults.vue?vue&type=script&lang=ts"
export * from "./Vaults.vue?vue&type=script&lang=ts"

import "./Vaults.vue?vue&type=style&index=0&id=153fec00&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-153fec00"

export default script